export default function Logo({ dark = false, compact = false }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <svg width={compact ? 34 : 40} height={compact ? 34 : 40} viewBox="0 0 64 64" aria-hidden="true">
        <defs>
          <linearGradient id="lg-gold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#E9DCC3" />
            <stop offset="0.5" stopColor="#C5A059" />
            <stop offset="1" stopColor="#8F6F33" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="12" fill={dark ? "#0B132B" : "#0B132B"} />
        <path d="M32 8 L52 16 V32 C52 44 44 52 32 56 C20 52 12 44 12 32 V16 Z" fill="none" stroke="url(#lg-gold)" strokeWidth="3" />
        <path d="M40 24 C40 21 37 19 32 19 C27 19 24 21 24 24.5 C24 31 40 29 40 37.5 C40 41 37 44 32 44 C27 44 24 41.5 24 38" fill="none" stroke="url(#lg-gold)" strokeWidth="3.5" strokeLinecap="round" />
      </svg>
      <span className="leading-none">
        <span className={`block font-display text-xl font-semibold tracking-tight ${dark ? "text-white" : "text-navy"}`}>
          Stratedge <span className="text-gold">UK</span>
        </span>
        {!compact && (
          <span className={`mt-1 block text-[10px] font-medium uppercase tracking-[0.22em] ${dark ? "text-slate-400" : "text-slate-500"}`}>
            Consulting & Training
          </span>
        )}
      </span>
    </span>
  );
}
